<button
  class="ui-category-tile"
  type="button"
  [class.ui-category-tile-tone-amber]="isAmber()"
  [class.ui-category-tile-tone-blue]="isBlue()"
  [class.ui-category-tile-tone-green]="isGreen()"
  [class.ui-category-tile-tone-pink]="isPink()"
  [class.ui-category-tile-tone-violet]="isViolet()"
  [class.ui-category-tile-tone-teal]="isTeal()"
  [disabled]="disabled()"
  [attr.aria-label]="name()"
  (click)="handleSelected($event)"
>
  <span class="ui-category-tile-top">
    <span class="ui-category-tile-icon" aria-hidden="true">
      <ui-library-icon [name]="iconName()" [fallbackLabel]="iconLabel()" />
    </span>
    @if (count() !== null) {
      <span class="ui-category-tile-count">{{ count() }}</span>
    }
  </span>
  <span class="ui-category-tile-copy">
    <span class="ui-category-tile-name">{{ name() }}</span>
    @if (hasHint()) {
      <span class="ui-category-tile-hint">{{ hint() }}</span>
    }
  </span>
</button>
